import { withInstall } from '@jdesign-vue/utils'

import Col from './src/col.vue'

export const JdCol = withInstall(Col)
export default JdCol

export * from './src/col'
